const isInMobileApp = 'undefined' !== typeof window.nativeBabbelApp;

export default isInMobileApp;
